import React, { useState } from "react";
import { adminApi } from "../../api";
import { saveSession } from "../../utils/authStorage";

/**
 * Admin "View As" — opens a venue's client portal in a new tab as an admin,
 * without client credentials. Mints a short-lived, impersonation-stamped client
 * token (backend: POST /admin/venues/:id/impersonate), writes it into the
 * client-namespaced session, and opens /client. Sessions are namespaced per
 * portal, so the admin's own tab/session is untouched.
 */
export default function ViewAsButton({ venueId, className = "btn btn-outline btn-sm", label = "View As" }) {
  const [busy, setBusy] = useState(false);

  async function go() {
    if (busy) return;
    setBusy(true);
    try {
      const { token, user } = await adminApi.impersonateVenue(venueId);
      // Write the client session (explicit portal so an admin page doesn't
      // write to the admin namespace), then open the client portal.
      saveSession(user, token, "client");
      window.open("/client", "_blank");
    } catch (err) {
      alert("View As failed: " + (err?.message || err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      className={className}
      onClick={go}
      disabled={busy}
      title="Open this venue's client portal as an admin (no login) — opens in a new tab"
    >
      {busy ? "…" : label}
    </button>
  );
}
